import { useFeatureIsOn } from '@growthbook/growthbook-react'
import React, { useEffect, useState } from 'react'
import { Tabs } from 'antd'
import { REPORT } from 'modules/core/constants'
import { useTranslation } from 'react-i18next'
import { Comparative, Evolution, Variation } from './components'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import planning from 'modules/planning'
import PropTypes from 'prop-types'

const TabsReports = ({
  periodList,
  isEvolutionLoading,
  iscomparativeLoading,
  filters,
  selectedDates,
  groupProjection,
  periodTableSettings,
  setPeriodTableSettings,
  selectedProjection,
  setSelectedProjection,
  referenceBase,
  setReferenceBase,
  referenceComparison,
  setReferenceComparison,
  keyComparisonTable,
  setKeyComparisonTable,
  setTablePagination,
  tablePagination,
  onRefetch,
  onRefetch2,
  tabKey,
  setTabKey,
  lineVertical,
  setLineVertical,
  onRefetchComparative,
  onRefetchEvolution,
  setDataComments,
  dataComments,
  onRefetchComments,
  loadingComments,
  isProgressLoading,
  showProgressBar,
  commentKey,
  currencyData,
  referenceBaseVariant,
  setReferenceBaseVariant,
  referenceComparisonVariant,
  setReferenceComparisonVariant,
  localReferenceBase,
  setLocalReferenceBase,
  dataEvolutionChart,
  lineId,
  isLoadingGraphAndKpi,
  overallBudgetSelectAnalysis,
  type,
  setBaseSelect,
  baseSelect,
  settingsEvolution,
  settingsComparison,
  settingsVariation,
  setSettingsEvolution,
  setSettingsComparison,
  setSettingsVariation,
}) => {
  const [showTableqp, setShowTableqp] = useState(false)
  const [exist, setExist] = useState(false)
  let { periodId, reportId } = useParams()
  const { t } = useTranslation()
  const dataPeriod = periodList.find((el) => el.id === parseInt(periodId))
  const enabledVariant = useFeatureIsOn('feature-variant-analysis')

  useEffect(() => {
    setShowTableqp(false)
  }, [])

  const handleClick = (key) => {
    setTabKey(key)
    setBaseSelect('real')
    setLocalReferenceBase({ value: 'real', id: null })
    setSelectedProjection({ value: 'real', id: null })
    setReferenceBaseVariant({ value: 'real', id: null })
    setShowTableqp(false)
    localStorage.removeItem('dataTable')
    setExist(false)
    window.history.replaceState(
      null,
      '',
      `/analisis/${periodId}/reportesplika/${reportId}/${type}/${currencyData.id}/${key}`,
    )
  }

  return (
    <Tabs key={tabKey} defaultActiveKey={tabKey} onChange={handleClick} size="small">
      <Tabs.TabPane tab={t('FIELD_EVOLUTION')} key={REPORT.REPORTS_KEYS.EVOLUTION_KEY}>
        {tabKey === REPORT.REPORTS_KEYS.EVOLUTION_KEY && (
          <Evolution
            loading={isEvolutionLoading}
            selectedFilters={filters}
            selectedDates={selectedDates}
            selectedPeriod={dataPeriod}
            groupProjection={groupProjection}
            periodTableSettings={periodTableSettings}
            setPeriodTableSettings={setPeriodTableSettings}
            selectedProjection={selectedProjection}
            setSelectedProjection={setSelectedProjection}
            setTablePagination={setTablePagination}
            tablePagination={tablePagination}
            onRefetch={onRefetch}
            lineVertical={lineVertical}
            setLineVertical={setLineVertical}
            onRefetchEvolution={onRefetchEvolution}
            setDataComments={setDataComments}
            dataComments={dataComments}
            onRefetchComments={onRefetchComments}
            loadingComments={loadingComments}
            isProgressLoading={isProgressLoading}
            showProgressBar={showProgressBar}
            commentKey={commentKey}
            currencyData={currencyData}
            dataEvolutionChart={dataEvolutionChart}
            lineId={lineId}
            isLoadingGraphAndKpi={isLoadingGraphAndKpi}
            tabKey={tabKey}
            type={type}
            showTableqp={showTableqp}
            setShowTableqp={setShowTableqp}
            setBaseSelect={setBaseSelect}
            exist={exist}
            setExist={setExist}
            settings={settingsEvolution}
            setSettings={setSettingsEvolution}
          />
        )}
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('FIELD_COMPARISONS')} key={REPORT.REPORTS_KEYS.COMPARISON_KEY}>
        {tabKey === REPORT.REPORTS_KEYS.COMPARISON_KEY && (
          <Comparative
            loading={iscomparativeLoading}
            selectedFilters={filters}
            selectedDates={selectedDates}
            selectedPeriod={dataPeriod}
            groupProjection={groupProjection}
            periodTableSettings={periodTableSettings}
            setPeriodTableSettings={setPeriodTableSettings}
            referenceBase={referenceBase}
            setReferenceBase={setReferenceBase}
            referenceComparison={referenceComparison}
            setReferenceComparison={setReferenceComparison}
            keyComparisonTable={keyComparisonTable}
            setKeyComparisonTable={setKeyComparisonTable}
            setTablePagination={setTablePagination}
            onRefetch={onRefetch2}
            onRefetchComparative={onRefetchComparative}
            setDataComments={setDataComments}
            dataComments={dataComments}
            onRefetchComments={onRefetchComments}
            loadingComments={loadingComments}
            isProgressLoading={isProgressLoading}
            showProgressBar={showProgressBar}
            commentKey={commentKey}
            currencyData={currencyData}
            localReferenceBase={localReferenceBase}
            setLocalReferenceBase={setLocalReferenceBase}
            overallBudgetSelectAnalysis={overallBudgetSelectAnalysis}
            tabKey={tabKey}
            type={type}
            showTableqp={showTableqp}
            setShowTableqp={setShowTableqp}
            exist={exist}
            setExist={setExist}
            settings={settingsComparison}
            setSettings={setSettingsComparison}
          />
        )}
      </Tabs.TabPane>
      {enabledVariant && (
        <Tabs.TabPane tab={t('FIELD_VARIATION_PXQ')} key={REPORT.REPORTS_KEYS.VARIATION_KEY}>
          {tabKey === REPORT.REPORTS_KEYS.VARIATION_KEY && (
            <Variation
              loading={iscomparativeLoading}
              groupProjection={groupProjection}
              referenceBase={referenceBaseVariant}
              setReferenceBase={setReferenceBaseVariant}
              referenceComparison={referenceComparisonVariant}
              setReferenceComparison={setReferenceComparisonVariant}
              onRefetchComparative={onRefetchComparative}
              setDataComments={setDataComments}
              dataComments={dataComments}
              onRefetchComments={onRefetchComments}
              loadingComments={loadingComments}
              commentKey={commentKey}
              currencyData={currencyData}
              isProgressLoading={isProgressLoading}
              showProgressBar={showProgressBar}
              tabKey={tabKey}
              type={type}
              showTableqp={showTableqp}
              setShowTableqp={setShowTableqp}
              baseSelect={baseSelect}
              setBaseSelect={setBaseSelect}
              exist={exist}
              setExist={setExist}
              settings={settingsVariation}
              setSettings={setSettingsVariation}
            />
          )}
        </Tabs.TabPane>
      )}
    </Tabs>
  )
}

const mapStateToProps = (state) => ({
  periodList: planning.selectors.getPeriodList(state),
})

const mapDispatchToProps = {}

TabsReports.propTypes = {
  onRefetch2: PropTypes.func,
  setLineVertical: PropTypes.func,
  onRefetchComparative: PropTypes.func,
  onRefetchEvolution: PropTypes.func,
  setDataComments: PropTypes.func,
  dataComments: PropTypes.array,
  onRefetchComments: PropTypes.func,
  loadingComments: PropTypes.bool,
  isProgressLoading: PropTypes.bool,
  showProgressBar: PropTypes.bool,
  commentKey: PropTypes.any,
  currencyData: PropTypes.shape({
    id: PropTypes.any,
  }),
  referenceBaseVariant: PropTypes.object,
  setReferenceBaseVariant: PropTypes.func,
  referenceComparisonVariant: PropTypes.object,
  setReferenceComparisonVariant: PropTypes.func,
  localReferenceBase: PropTypes.object,
  setLocalReferenceBase: PropTypes.func,
  dataEvolutionChart: PropTypes.array,
  lineId: PropTypes.any,
  isLoadingGraphAndKpi: PropTypes.bool,
  overallBudgetSelectAnalysis: PropTypes.any,
  type: PropTypes.any,
  setBaseSelect: PropTypes.func,
  baseSelect: PropTypes.string,
  periodList: PropTypes.array,
}

export default connect(mapStateToProps, mapDispatchToProps)(TabsReports)
